import { useEffect, useMemo } from "react";
import type { G_RelatedBook } from "~/lib/graphql";
import { QUANTITY_NUMBER, TRACKING_EVENT_TYPES, TRACKING_PRICE } from "~/lib/tracking/const";
import { sendTrackingViewItemList } from "~/lib/tracking/events";

type UseTrackingCollectionItemType = {
  collectionType: "videos" | "books";
  videos: {
    seasonId: string;
    video: {
      id: string;
      titleName: string;
      packageImage: string;
      isNewArrival: boolean;
      isExclusive: boolean;
    };
  }[];
  books: Pick<G_RelatedBook, "title" | "url" | "seriesId" | "thumbnail">[];
};

export const useTrackingCollectionItem = (args: UseTrackingCollectionItemType) => {
  const { collectionType, videos, books } = args;

  const collectionTypeVideoData = useMemo(() => {
    return videos.map(({ video }, idx) => {
      const { id, titleName } = video;

      return {
        product: {
          id,
          index: idx + 1,
          item_name: titleName,
          priceInfo: { price: TRACKING_PRICE },
        },
        quantity: QUANTITY_NUMBER,
      };
    });
  }, [videos]);

  const collectionTypeBooksData = useMemo(() => {
    return books.map((item, idx) => {
      return {
        product: {
          id: item.seriesId,
          index: idx + 1,
          item_name: item.title,
          priceInfo: { price: TRACKING_PRICE },
        },
        quantity: QUANTITY_NUMBER,
      };
    });
  }, [books]);

  useEffect(() => {
    if (collectionType === "videos" && videos.length > 0) {
      sendTrackingViewItemList(
        collectionTypeVideoData,
        TRACKING_EVENT_TYPES["CATEGORY_PAGE_VIEW"],
        null,
        "related_videos",
        null,
        null
      );
      return;
    }

    if (collectionType === "books" && books.length > 0) {
      sendTrackingViewItemList(
        collectionTypeBooksData,
        TRACKING_EVENT_TYPES["CATEGORY_PAGE_VIEW"],
        null,
        "related_books",
        null,
        null
      );
      return;
    }
  }, [collectionType, videos.length, books.length]);
};
